export default __webpack_public_path__ + "public/icons/arrow-with-shadow.svg?d2bb43deaee1b64a0afa6ad086f20c49";